import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    // Only call parent's connectedCallback if using infinite scroll
    if (this.paginationType === 'infinite_scroll') {
      super.connectedCallback();
    }

    // Setup numbered pagination controls if needed
    if (this.paginationType === 'numbered') {
      this.#setupPaginationControls();
    }
  }

  /**
   * Get the pagination type from the data attribute
   */
  get paginationType() {
    return this.dataset.paginationType || 'numbered';
  }

  /**
   * Setup event listeners for pagination controls
   */
  #setupPaginationControls() {
    // For numbered pagination, just let the browser handle the navigation normally
    // No need to preventDefault - the links will work as standard page navigation
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
